module.exports = __webpack_public_path__ + "img/Gallery_2_19.a2bc9132.jpeg";